import { h, Fragment } from 'preact';
import { useEffect, useState } from 'preact/hooks';
import Media from 'utils/media';


const ProductSpecs = ({ currentInputVariant, fromForm, ...props }) => {
  const currentVariantSource = !currentInputVariant ?
    props.product.variants.find(
      (v) =>
        JSON.stringify(v.selectedOptions) ===
        JSON.stringify(props.product.variantBySelectedOptions.selectedOptions),
    )
    :
    currentInputVariant;

  const [currentVariant, setCurrentVariant] =
    useState(currentVariantSource);

  const handleCurrentVariantUpdated = (e) => {
    const { currentProductData } = e.detail;
    setCurrentVariant(currentProductData.variants.find(
      (v) =>
        JSON.stringify(v.id) ===
        JSON.stringify(e.detail.currentVariant),
    ));
  };

  useEffect(() => {
    document.addEventListener("currentVariantUpdated", handleCurrentVariantUpdated);
    return () => document.removeEventListener('currentVariantUpdated', handleCurrentVariantUpdated);
  }, []);

  return (
    <>
      {(currentVariant?.sku ||
        currentVariant?.weight?.weightInUnit ||
        currentVariant?.detailsTray?.dimensionsValues ||
        currentVariant?.detailsTray?.dimensionsCopyCol2) && (
          <div className="relative" data-target='details-specs'>
            {fromForm && (
              <div className='mb-4'>
                <div className='utility-1 uppercase mt-7'>{props.detailsTraySpecsTitle}</div>
                {currentVariant?.detailsTray?.specsVideo &&
                  <div className="relative pb-[100%] mt-2.5">
                    <Media {...currentVariant?.detailsTray?.specsVideo}
                      className="absolute inset-0 object-cover w-full"
                      controlClass="!opacity-100 text-black bg-white"
                      mediaContentType='VIDEO'
                      previewImage={
                        currentVariant?.detailsTray?.specsVideo?.preview_image}
                      sources={currentVariant?.detailsTray?.specsVideo?.sources}
                      alt={currentVariant?.detailsTray?.specsVideo?.alt}
                    />
                  </div>
                }
              </div>
            )}
            <div className="flex gap-x-[31px] justify-between">
              <div className={`space-y-5${fromForm ? ' flex-1' : ''}`}>
                {props.detailsTrayDimensionsContentDimensionsTitle &&
                  currentVariant?.detailsTray?.dimensionsValues && (
                    <div className='space-y-2.5'>
                      <div className='utility-3 uppercase'>{props.detailsTrayDimensionsContentDimensionsTitle}</div>
                      <p className='paragraph-4'>{currentVariant?.detailsTray?.dimensionsValues}</p>
                    </div>
                  )}
                {props.detailsTrayDimensionsContentWeightTitle &&
                  currentVariant?.weight?.weightInUnit && (
                    <div className='space-y-2.5'>
                      <div className='utility-3 uppercase'>{props.detailsTrayDimensionsContentWeightTitle}</div>
                      <p className='paragraph-4'>{currentVariant?.weight?.weightInUnit} {currentVariant?.weight?.unit}</p>
                    </div>
                  )}
                {props.detailsTrayDimensionsContentStyleTitle &&
                  currentVariant?.sku && (
                    <div className='space-y-2.5'>
                      <div className='utility-3 uppercase'>{props.detailsTrayDimensionsContentStyleTitle}</div>
                      <p className='paragraph-4'>{currentVariant?.sku}</p>
                    </div>
                  )}
              </div>
              {props.detailsTrayDimensionsContentWhatFitsTitle &&
                currentVariant?.detailsTray?.dimensionsCopyCol2 && (
                  <div className={`pr-5${fromForm ? ' flex-1' : ''}`}>
                    <p className='utility-3 mb-2 uppercase'>{props.detailsTrayDimensionsContentWhatFitsTitle}</p>
                    <div className='space-y-2' dangerouslySetInnerHTML={{ __html: currentVariant?.detailsTray?.dimensionsCopyCol2 }} />
                  </div>
                )}
            </div>
          </div>
        )}
    </>
  );
};

export default ProductSpecs;
